import React, { useEffect, useContext } from 'react';
import { Typography, Grid, Card, CardContent, Divider, Avatar, IconButton, Chip, Box, Button } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faBox } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from "react-router-dom";
import CachedIcon from "@mui/icons-material/Cached";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import dashRoutes from "../../models/general/routes";
import { observer } from "mobx-react-lite";
import { account } from '../../shared/Utils';
import { Menu } from '../../app/util/permisos';
import { getFormatDate, getDayOfWeek } from '../../app/util/util';
import { RootStoreContext } from "../../app/store/root";
import { EnumCatalogosEncabezado, EnumStatusShipmentString } from '../../shared/Enumerables';
import { ModalComponent } from "../../app/common/ModalComponent";
import ModalDetalles from '../../shared/modals/ModalDetalles';
import { toJS } from "mobx";

function DashboardProveedores() {

    const navigate = useNavigate()
    const rootStore = useContext(RootStoreContext)

    const {
        getMovimientosProveedor: _getMovimientosProveedor,
        getEnviosProgramadosRevision: _getEnviosProgramadosRevision,
        revisoEnviosProgramados: _revisoEnviosProgramados,
        revisonMovimientoUsuario,
        getById
    } = rootStore.shipmentStore

    const {
        getValoresCatalogo
    } = rootStore.catalogosStore


    const [movimientosProveedor, setMovimientosProveedor] = React.useState([])
    const [estatusEnvios, setEstatusEnvios] = React.useState([])
    const [enviosProgramados, setEnviosProgramados] = React.useState([])

    const [todayFormat, setTodayFormat] = React.useState('')
    const [dayOfWeekFormat, setDayOfWeekFormat] = React.useState('')
    const [ultimaActualizacion, setUltimaActualizacion] = React.useState('')
    var timerTime;
    var valorTimerTime = -1;

    useEffect(() => {
        document.title = 'Lilofy | Dashboard';
        if (!account.getPermisosUsuario().some(a => a.clavePermiso == Menu.ProveedorDashboard && a.tienePermiso)) {
            console.log('No tengo permisos para el Dashboard de proveedores');
            navigate("/Proveedores/AccessDenied");
        } else {
            loadDataPage()
        }
    }, [])


    useEffect(() => {
        return () => {
            clearTimeout(timerTime)
        }
    }, [])

    const loadDataPage = async () => {
        getMovimientosToday()
        actualizarTimerTime()
        getEnviosProgramadosRevision()
        setTodayFormat(getFormatDate(new Date(), 'dd/MM/yyyy'))
        setDayOfWeekFormat(getDayOfWeek(new Date()))
    }

    const getMovimientosToday = async () => {
        let data = await _getMovimientosProveedor()
        if (data?.success) {
            var localEstatusEnvios = estatusEnvios;            
            if (localEstatusEnvios.length === 0) {
                let resp = await getValoresCatalogo(EnumCatalogosEncabezado.EstatusEnvios)
                localEstatusEnvios = resp ?? localEstatusEnvios;
                setEstatusEnvios(localEstatusEnvios)
            }
            let valores = data.data.map(a => { return { ...a, estatus: localEstatusEnvios.find(b => b.id == a.idEstatus)?.valor ?? "" } })
            setMovimientosProveedor(valores)
        }
    }

    const getEnviosProgramadosRevision = async () => {
        let data = await _getEnviosProgramadosRevision()
        if (data?.success) {
            setEnviosProgramados(data.data)
        }
    }

    const autoRefreshTimerTime = () => {
        const tiempoRefresh = 1
        resetTimer()
        function resetTimer() {
            clearTimeout(timerTime);
            timerTime = setTimeout(actualizarTimerTime, tiempoRefresh * 60000)
        }
    }

    const actualizarTimerTime = () => {
        //incrementar el valorTimerTime en 1 porque ya paso un minuto
        valorTimerTime = valorTimerTime + 1
        //si ya pasaron 5 minutos, obtener los registros e inicializar valorTimerTime en 0 porque acaba de actualizar 
        if (valorTimerTime >= 5) {
            getMovimientosToday()
            valorTimerTime = 0
        }

        //actualizar la leyenda segun el tiempo transcurrido en valorTimerTime
        let _ultimaActualizacion = '';

        if (valorTimerTime == 0)
            _ultimaActualizacion = 'Última actualización ahora mismo'
        else if (valorTimerTime == 1)
            _ultimaActualizacion = 'Última actualización hace 1 minuto'
        else
            _ultimaActualizacion = 'Última actualización hace ' + valorTimerTime + ' minutos'

        setUltimaActualizacion(_ultimaActualizacion)
        //reiniciamos el timer para ejecutar un minuto despues
        autoRefreshTimerTime()
    }

    const clickActualizarManual = () => {
        getMovimientosToday()
        setUltimaActualizacion('Última actualización ahora mismo')
        valorTimerTime = -1
    }

    const cerrarTodas = async () => {
        let idMovimientos = movimientosProveedor.map(a => { return a.idMovimientoGuia })
        let resp = await revisonMovimientoUsuario(idMovimientos)
        if (resp?.success) {
            getMovimientosToday()
        }
    }

    const cerrarMovimiento = async (idMovimientoGuia) => {
        let idMovimientos = [idMovimientoGuia]
        let resp = await revisonMovimientoUsuario(idMovimientos)
        if (resp?.success) {
            getMovimientosToday()
        }
    }

    const detalleEnvio = async (idGuia) => {
        rootStore.logisticBackdropStore.openLoading()
        await getById(idGuia)
        setOpenDialogDetalle(true)
        rootStore.logisticBackdropStore.closeLoading()
    }

    const revisoEnviosProgramados = async (idGuia) => {
        rootStore.logisticBackdropStore.openLoading()
        let idGuias = [idGuia]
        let resp = await _revisoEnviosProgramados(idGuias)
        if (resp?.success) {
            getEnviosProgramadosRevision()
        }
        rootStore.logisticBackdropStore.closeLoading()
    }

    const getOptions = (dashRoutes) => {
        //let optionsUsers = dashRoutes.filter(dashRoutes => dashRoutes.layout === "/Proveedores");
        let permisosUsuario = account.getPermisosUsuario()
        let optionsUsers = dashRoutes.filter(a => permisosUsuario.filter(a => a.esMenu && a.tienePermiso).map(a => { return a.clavePermiso }).includes(a.clave))
        return optionsUsers.map((prop, key) => {
            return (
                <Link to={prop.layout + prop.path} key={key} className="linksTo">
                    <Box width={'150px'} height={'100px'}>
                        <Card className='card card-button' sx={{ height: '100%' }}>
                            <CardContent className='card-body text-center'>
                                <Grid container direction={'column'} justifyContent="center" alignItems="center">
                                    <Box color="primary.main" sx={{ fontSize: 26 }}>
                                        {prop.icon}
                                    </Box>
                                    <Typography variant='body1'>{prop.name}</Typography>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                </Link>

            );
        });
    }

    var createOptions = getOptions(dashRoutes);

    //DIALOG DETALLE
    const [openDetalle, setOpenDialogDetalle] = React.useState(null);

    const closeDialogDetalle = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpenDialogDetalle(false);
    };

    return (
        <>
            <div className="main-container" >
                <Grid container gap={8} justifyContent="center" alignItems={"center"} mb={3}>
                    {createOptions}
                </Grid>
                <Grid container direction={'row'} spacing={3}>
                    <Grid item sm={6} md={8} direction={'column'}>
                        <Grid container spacing={1} direction={'row'} justifyContent="space-between" alignItems="center" mb={2}>
                            <Grid item>
                                <div className='mb-2 d-flex' style={{ alignItems: 'center' }}>
                                    <Box sx={{ marginRight: '16px', fontSize: 25 }} color="primary.main">
                                        <CachedIcon style={{ cursor: 'pointer' }} onClick={() => { clickActualizarManual() }} />
                                    </Box>
                                    <Typography color='primary' variant='h4'>
                                        Actualizaciones
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item>
                                <Typography variant='subtitle1'>
                                    {ultimaActualizacion}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography color='primary' variant='h4' align='right'>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        disabled={movimientosProveedor.length == 0}
                                        onClick={cerrarTodas}
                                    >
                                        Cerrar todas
                                    </Button>
                                </Typography>
                            </Grid>
                        </Grid>
                        {/* CONTENEDOR CON LAS ACTUALIZACIONES */}
                        <Grid container spacing={2} >
                            {movimientosProveedor.map((movimiento) => {
                                return (
                                    <Grid item xs={12}>
                                        <Card className="card card-button">
                                            <CardContent variant='smallCard' sx={{ padding: '10px !important' }}>
                                                <Grid container direction={'column'}>
                                                    <Grid item xs={'auto'} display={'flex'} justifyContent={'end'}>
                                                        <IconButton variant='closeIcon'
                                                            onClick={(e) => {
                                                                e.preventDefault()
                                                                cerrarMovimiento(movimiento.idMovimientoGuia)
                                                            }}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item onClick={(e) => {
                                                        e.preventDefault()
                                                        detalleEnvio(movimiento.idGuia)
                                                    }}>
                                                        <Grid container direction={'row'} spacing={2} columns={16} >
                                                            {/* {movimiento.estatus} */}
                                                            {movimiento.estatus?.toUpperCase() == EnumStatusShipmentString.Creado &&
                                                                <Grid lg={3} md={4} sm={6} xs={4} item direction={'column'} alignItems="center" display={'flex'}>
                                                                    <Avatar sx={{ width: 50, height: 50, bgcolor: 'secondary.main', marginBottom: '5px' }} variant="rounded">
                                                                        <FontAwesomeIcon icon={faBarcode} />
                                                                    </Avatar>
                                                                    <Chip label={movimiento.estatus} color="secondary" />
                                                                    <Typography variant='subtitle' mt={1} className="text-center">
                                                                        {getFormatDate(movimiento.fechaMovimiento)}
                                                                    </Typography>
                                                                </Grid>
                                                            }
                                                            {movimiento.estatus.toUpperCase() == EnumStatusShipmentString.Entregado &&
                                                                <Grid lg={3} md={4} sm={6} xs={4} item direction={'column'} alignItems="center" display={'flex'}>
                                                                    <Avatar sx={{ width: 50, height: 50, bgcolor: 'success.main', marginBottom: '5px' }} variant="rounded">
                                                                        <FontAwesomeIcon icon={faBox} />
                                                                    </Avatar>
                                                                    <Chip label={movimiento.estatus} color="success" />
                                                                    <Typography variant='subtitle' mt={1} className="text-center">
                                                                        {getFormatDate(movimiento.fechaMovimiento)}
                                                                    </Typography>
                                                                </Grid>
                                                            }
                                                            {(movimiento.estatus.toUpperCase() == EnumStatusShipmentString.Recibido ||
                                                                movimiento.estatus.toUpperCase() == EnumStatusShipmentString.Documentado ||
                                                                movimiento.estatus.toUpperCase() == EnumStatusShipmentString.En_Transito ||
                                                                movimiento.estatus.toUpperCase() == EnumStatusShipmentString.No_Entregado) &&
                                                                <Grid lg={3} md={4} sm={6} xs={4} item direction={'column'} alignItems="center" display={'flex'}>
                                                                    <Avatar sx={{ width: 50, height: 50, bgcolor: 'primary.main', marginBottom: '5px' }} variant="rounded">
                                                                        <LocalShippingIcon />
                                                                    </Avatar>
                                                                    <Chip label={movimiento.estatus} color="primary" />
                                                                    <Typography variant='subtitle' mt={1} className="text-center">
                                                                        {getFormatDate(movimiento.fechaMovimiento)}
                                                                    </Typography>
                                                                </Grid>
                                                            }
                                                            <Grid lg={4} md={4} sm={10} xs={6} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                                <Typography variant='h6' className="text-center">
                                                                    No. de guía
                                                                </Typography>
                                                                <Typography variant='subtitle' mt={2} className="text-center">
                                                                    #{movimiento.numeroGuia}
                                                                </Typography>
                                                            </Grid>

                                                            {/* <Grid item xs="auto" p={0}>
                                                                <Divider orientation="vertical" flexItem />
                                                            </Grid> */}

                                                            {/* <Grid sm={4} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                                <Typography variant='h6'>
                                                                    {movimiento.estatus.toUpperCase() == EnumStatusShipmentString.Creado
                                                                        ? 'Se ha creado una nueva guía' : 'El envío cambió de estatus'}
                                                                </Typography>
                                                            </Grid> */}

                                                            {(movimiento.estatus.toUpperCase() != EnumStatusShipmentString.Creado && movimiento.estatus.toUpperCase() != EnumStatusShipmentString.Recibido) &&
                                                                <Grid lg={4} md={4} sm={8} xs={6} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                                    <Typography variant='h6' className="text-center">
                                                                        No. de carta porte
                                                                    </Typography>
                                                                    <Typography variant='subtitle' mt={2} className="text-center">
                                                                        #{movimiento.numeroCartaPorte}
                                                                    </Typography>
                                                                </Grid>
                                                            }
                                                            {(movimiento.estatus.toUpperCase() == EnumStatusShipmentString.Creado || movimiento.estatus.toUpperCase() == EnumStatusShipmentString.Recibido) &&
                                                                <Grid lg={4} md={4} sm={6} xs={6} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                                    <Typography variant='h6' className="text-center">
                                                                        Destino
                                                                    </Typography>
                                                                    <Typography variant='subtitle' mt={2} className="text-center">
                                                                        {movimiento.destino}
                                                                    </Typography>
                                                                </Grid>
                                                            }
                                                            {(movimiento.estatus.toUpperCase() != EnumStatusShipmentString.Creado && movimiento.estatus.toUpperCase() != EnumStatusShipmentString.Recibido) &&
                                                                <Grid lg={4} md={4} sm={8} xs={8} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                                    <Typography variant='h6' className="text-center">
                                                                        Fecha estimada de llegada
                                                                    </Typography>
                                                                    <Typography variant='subtitle' mt={2} className="text-center">
                                                                        {getFormatDate(movimiento.fechaEstimadaLlegada)}
                                                                    </Typography>
                                                                </Grid>
                                                            }
                                                            {/* <Grid sm={3} item direction={'column'} >
                                                                <Typography variant='h6'>
                                                                    Datos de envío
                                                                </Typography>
                                                                <Typography variant='subtitle'>
                                                                    {movimiento.destino}
                                                                </Typography>
                                                            </Grid> */}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>

                    {/* Programadas */}
                    <Grid item sm={6} md={4}>
                        <div className='mb-2 d-flex' style={{ alignItems: 'center' }}>
                            <Box sx={{ marginRight: '16px', fontSize: 25 }} color="primary.main">
                                <DescriptionIcon />
                            </Box>
                            <Typography color='primary' variant='h4'>
                                Programadas para hoy
                            </Typography>
                        </div>
                        <Grid container spacing={2}>
                            {enviosProgramados.map((envio) => {
                                return (
                                    <Grid item xs={12}>
                                        <Card className="card card-button" sx={{ backgroundColor: 'primary' }}>
                                            <CardContent variant='smallCard'>
                                                <Grid container direction={'column'}>
                                                    <Grid item xs={'auto'} display={'flex'} justifyContent={'end'}>
                                                        <IconButton variant='closeIcon'
                                                            onClick={(e) => {
                                                                e.preventDefault()
                                                                revisoEnviosProgramados(envio.idGuia)
                                                            }}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid container direction={'column'} onClick={(e) => { e.preventDefault(); detalleEnvio(envio.idGuia) }}>
                                                        <Grid item direction={'column'} mb={2} >
                                                            <Typography variant='h6'>
                                                                No. de rastreo
                                                            </Typography>
                                                            <Typography variant='subtitle' mt={2}>
                                                                #{envio.numeroGuia}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item direction={'column'}>
                                                            <Typography variant='h6'>
                                                                Fecha prevista entrega
                                                            </Typography>
                                                            <Typography variant='subtitle' mt={2}>
                                                                {getFormatDate(envio.fechaEstimadaLlegada, 'dd/MM/yyyy')}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <ModalComponent
                Open={openDetalle}
                HandleClose={() => closeDialogDetalle()}
                ClassName="modal-xl"
                Body={() => (
                    <ModalDetalles
                        onClose={closeDialogDetalle}
                    />
                )}
            />
        </>
    );
}

export default observer(DashboardProveedores);
